import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './SubmittalDocuments.css';
import { FormGroup, Col, ControlLabel } from 'react-bootstrap';
import uploadSvg from 'images/upload.svg';
import removeIconPng from 'images/remove.png';
import Dropzone from 'react-dropzone';
import DocumentLinkBluebeam from 'components/shared/document/DocumentLinkBluebeam';
import ImageUpload from 'components/shared/image-upload/ImageUpload';

class SubmittalDocuments extends Component {
  static propTypes = {
    submittal: PropTypes.shape({}),
    submittalAddlAssignee: PropTypes.shape({}),
    form: PropTypes.shape({}).isRequired,
    readOnly: PropTypes.bool,
    fileType: PropTypes.oneOf(['req', 'res']).isRequired,
    handleFormChange: PropTypes.func.isRequired,
    handleFormDeleteFile: PropTypes.func.isRequired,
  };

  static defaultProps = {
    submittal: null,
    submittalAddlAssignee: null,
  };

  constructor(props) {
    super(props);

    switch (props.fileType) {
      case 'req':
        this.imgsAttr = 'reqImages';
        this.docsAttr = 'reqDocs';
        this.imgsDelAttr = 'reqImagesDelete';
        this.docsDelAttr = 'reqDocsDelete';
        this.submittalImgsAttr = 'request_images';
        this.submittalDocsAttr = 'request_documents';
        break;
      case 'res':
        this.imgsAttr = 'resImages';
        this.docsAttr = 'resDocs';
        this.imgsDelAttr = 'resImagesDelete';
        this.docsDelAttr = 'resDocsDelete';
        this.submittalImgsAttr = 'response_images';
        this.submittalDocsAttr = 'response_documents';
        break;
      default:
    }

    if (props.form.id) {
      this.initFiles(props);
    }
  }

  filesPresent = (attr) => {
    const { submittal, fileType } = this.props;
    const submittalFilesPresent = submittal && submittal[attr].length > 0;
    const addlAssigneesFilesPresent =
      submittal &&
      fileType === 'res' &&
      submittal.submittal_addl_assignees.find(
        (addlAssignee) => addlAssignee[attr].length > 0
      );
    return !!(submittalFilesPresent || addlAssigneesFilesPresent);
  };

  mapFiles = (files, type) => {
    return (files || []).map((file) => {
      return {
        id: file.id,
        url: file[type].url,
        preview: file[type].gallery && file[type].gallery.url,
      };
    });
  };

  initFiles = (props) => {
    const { submittalAddlAssignee, form, fileType } = props;
    if (submittalAddlAssignee && fileType === 'res') {
      this.props.handleFormChange(
        this.imgsAttr,
        this.mapFiles(submittalAddlAssignee[this.submittalImgsAttr], 'image')
      );
      this.props.handleFormChange(
        this.docsAttr,
        this.mapFiles(submittalAddlAssignee[this.submittalDocsAttr], 'document')
      );
    } else {
      this.props.handleFormChange(
        this.imgsAttr,
        this.mapFiles(form[this.submittalImgsAttr], 'image')
      );
      this.props.handleFormChange(
        this.docsAttr,
        this.mapFiles(form[this.submittalDocsAttr], 'document')
      );
    }
  };

  setImages = (files, imagesRef) => {
    let images = imagesRef.slice();
    files.forEach(function (val) {
      images.push({
        url: URL.createObjectURL(val),
        file: val,
      });
    });

    return images;
  };

  setSubmittalImages = (files) => {
    const images = this.setImages(files, this.props.form[this.imgsAttr]);
    this.props.handleFormChange(this.imgsAttr, images);
  };

  removeSubmittalImage = (index) => {
    const img = this.props.form[this.imgsAttr][index];
    this.props.form[this.imgsAttr].splice(index, 1);
    this.props.handleFormDeleteFile(this.imgsDelAttr, img);
    this.props.handleFormChange(this.imgsAttr, this.props.form[this.imgsAttr]);
  };

  dropDocuments = (files, docsRef) => {
    let docs = docsRef.slice();
    files.forEach(function (val) {
      docs.push({
        file: val,
        name: val.name,
      });
    });

    return docs;
  };

  dropSubmittalDocuments = (files) => {
    const docs = this.dropDocuments(files, this.props.form[this.docsAttr]);
    this.props.handleFormChange(this.docsAttr, docs);
  };

  removeSubmittalDocument = (index) => {
    const doc = this.props.form[this.docsAttr][index];
    this.props.form[this.docsAttr].splice(index, 1);
    this.props.handleFormDeleteFile(this.docsDelAttr, doc);
    this.props.handleFormChange(this.docsAttr, this.props.form[this.docsAttr]);
  };

  filteredAddlAssignees = () => {
    const { submittal, submittalAddlAssignee } = this.props;
    return submittal.submittal_addl_assignees.filter(
      (addlAssignee) =>
        !submittalAddlAssignee ||
        submittalAddlAssignee.assignee_id !== addlAssignee.assignee_id
    );
  };

  renderUploaderName = (uploadedBy) => {
    return (
      uploadedBy && (
        <div>
          {uploadedBy.first_name} {uploadedBy.last_name}
        </div>
      )
    );
  };

  render() {
    const {
      submittal,
      submittalAddlAssignee,
      form,
      fileType,
      readOnly,
    } = this.props;
    const filteredAddlAssignees =
      submittal && fileType === 'res' && this.filteredAddlAssignees();
    return (
      <FormGroup className="submittal-documents">
        <Col sm={12}>
          {(!readOnly || this.filesPresent(this.submittalDocsAttr)) && (
            <FormGroup>
              <Col componentClass={ControlLabel} sm={1}>
                Documents
              </Col>
              <Col sm={8}>
                {filteredAddlAssignees &&
                  filteredAddlAssignees.map((addlAssignee) => {
                    return this.mapFiles(
                      addlAssignee[this.submittalDocsAttr],
                      'document'
                    ).map((doc, index) => {
                      return (
                        <div
                          className="doc-viewer doc-viewer-read-only"
                          key={index}
                        >
                          <DocumentLinkBluebeam file={doc} />
                          {this.renderUploaderName(addlAssignee.assignee)}
                        </div>
                      );
                    });
                  })}
                {submittalAddlAssignee &&
                  form[this.submittalDocsAttr] &&
                  this.mapFiles(form[this.submittalDocsAttr], 'document').map(
                    (doc, index) => {
                      return (
                        <div
                          className="doc-viewer doc-viewer-read-only"
                          key={index}
                        >
                          <DocumentLinkBluebeam file={doc} />
                          {this.renderUploaderName(submittal.responded_by)}
                        </div>
                      );
                    }
                  )}
                {form[this.docsAttr] &&
                  form[this.docsAttr].map((doc, index) => {
                    return (
                      <div
                        className={`doc-viewer${
                          readOnly ? ' doc-viewer-read-only' : ''
                        }`}
                        key={index}
                      >
                        {!readOnly && (
                          <img
                            className="remove-doc-icon"
                            src={removeIconPng}
                            alt="remove"
                            onClick={() => this.removeSubmittalDocument(index)}
                          />
                        )}
                        <DocumentLinkBluebeam file={doc} />
                        {readOnly &&
                          fileType === 'res' &&
                          this.renderUploaderName(
                            submittalAddlAssignee
                              ? submittalAddlAssignee.assignee
                              : submittal.responded_by
                          )}
                      </div>
                    );
                  })}
                {!readOnly && (
                  <Dropzone
                    accept="application/pdf, .doc, .docx, .xls, .xlsx"
                    className="dropzone-container"
                    onDrop={this.dropSubmittalDocuments}
                  >
                    <span>Please drag and drop any file into this area</span>
                    <img src={uploadSvg} alt="upload" />
                  </Dropzone>
                )}
              </Col>
            </FormGroup>
          )}
          {(!readOnly || this.filesPresent(this.submittalImgsAttr)) && (
            <FormGroup>
              <Col componentClass={ControlLabel} sm={1}>
                Photos
              </Col>
              <Col sm={8}>
                {filteredAddlAssignees &&
                  filteredAddlAssignees
                    .filter(
                      (addlAssignee) =>
                        addlAssignee[this.submittalImgsAttr].length > 0
                    )
                    .map((addlAssignee, index) => {
                      return (
                        <div key={index} className="img-viewer">
                          <ImageUpload
                            extensions={['.jpg', '.jpeg', '.gif', '.png']}
                            images={this.mapFiles(
                              addlAssignee[this.submittalImgsAttr],
                              'image'
                            )}
                            readOnly={true}
                          />
                          {this.renderUploaderName(addlAssignee.assignee)}
                        </div>
                      );
                    })}
                {submittalAddlAssignee &&
                  form[this.submittalImgsAttr] &&
                  form[this.submittalImgsAttr].length > 0 && (
                    <div className="img-viewer">
                      <ImageUpload
                        extensions={['.jpg', '.jpeg', '.gif', '.png']}
                        images={this.mapFiles(
                          form[this.submittalImgsAttr],
                          'image'
                        )}
                        readOnly={true}
                      />
                      {this.renderUploaderName(submittal.responded_by)}
                    </div>
                  )}
                <div
                  className={`img-viewer${
                    !form[this.imgsAttr] || form[this.imgsAttr].length === 0
                      ? ' img-viewer-empty'
                      : ''
                  }`}
                >
                  <ImageUpload
                    extensions={['.jpg', '.jpeg', '.gif', '.png']}
                    images={form[this.imgsAttr]}
                    readOnly={readOnly}
                    onRemove={(index) => this.removeSubmittalImage(index)}
                    onUpload={(files) => this.setSubmittalImages(files)}
                  />
                  {readOnly &&
                    fileType === 'res' &&
                    form[this.imgsAttr] &&
                    form[this.imgsAttr].length > 0 &&
                    this.renderUploaderName(
                      submittalAddlAssignee
                        ? submittalAddlAssignee.assignee
                        : submittal.responded_by
                    )}
                </div>
              </Col>
            </FormGroup>
          )}
        </Col>
      </FormGroup>
    );
  }
}

export default connect()(SubmittalDocuments);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-submittal-log/SubmittalDocuments.js